import {AuthProfile, WishlistPreview} from "@/api/types.ts";
import {TbChevronRight, TbEye, TbEyeOff, TbEyeShare} from "react-icons/tb";
import {Caption, Cell} from "@telegram-apps/telegram-ui";
import {useNavigation} from "@/providers/NavigationProvider.tsx";
import {useTranslation} from "react-i18next";
import {renderWishesCount} from "@/helpers/translate/i18n.ts";
import {useAuthProfile} from "@/providers/AuthProfileProvider.tsx";

export const WishlistCell = ({wishlist} : {wishlist: WishlistPreview})  => {
  const { navigateToRoute } = useNavigation();
  const { t } = useTranslation();
  let authProfileFromContext: AuthProfile | undefined = undefined;
  try {
    const { authProfile } = useAuthProfile();
    authProfileFromContext = authProfile
  } catch (e) { /* empty */ }

  const onClick = () => {
    if (authProfileFromContext) {
      navigateToRoute(`/main/wishlists/${wishlist.id}`);
    } else {
      navigateToRoute(`/wishlists/${wishlist.id}`);
    }
  }

  return <Cell key={"wishlist_"+wishlist.id}
               description={<div className={"flex items-center gap-1"}>
                 {wishlist.access === 'public' && <><TbEye size={20}/>{t('privacy.public.shortDescription')}</>}
                 {wishlist.access === 'link' && <><TbEyeShare size={20}/>{t('privacy.link.shortDescription')}</>}
                 {wishlist.access === 'private' && <><TbEyeOff size={20}/>{t('privacy.private.shortDescription')}</>}
               </div>}
               after={<Caption weight={"2"} className={"flex gap-1 items-center tg-link-color text-center"}>
                 {renderWishesCount(wishlist.wishesCount)}
                 <TbChevronRight size={20}/>
               </Caption>}
               onClick={onClick}>
    {wishlist.title}
  </Cell>
}
